import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductShowcase.css';

const ProductShowcase = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const navigate = useNavigate();

  const categories = [
    { id: 'all', name: 'All Products' },
    { id: 'womens-health', name: 'Women\'s Health' },
    { id: 'digestive-health', name: 'Digestive Health' },
    { id: 'respiratory-care', name: 'Respiratory Care' },
    { id: 'liver-health', name: 'Liver Health' },
    { id: 'pain-relief', name: 'Pain Relief' },
    { id: 'pediatric-care', name: 'Pediatric Care' },
    { id: 'diabetes-care', name: 'Diabetes Care' }
  ];

  const products = [
    {
      id: 1,
      name: 'HEMA-CORDIAL',
      category: 'womens-health',
      rating: 4.9,
      reviews: 245,
      badge: 'Best Seller',
      benefits: ['Menstrual Disorders', 'Uterine Tonic', 'Natural Sedative'],
      description: 'Unique remedy for menstrual complaints and functional uterine bleeding. Contains Asoka Bark, Ashwagandha, Lodhra, Shatavari.',
      dosage: '10-20ml twice daily before meals',
      packing: '200ml & 400ml bottles',
      image: '/photos/hema_coridal.jpeg'
    },
    {
      id: 2,
      name: 'GASSO-WIN',
      category: 'digestive-health',
      rating: 4.7,
      reviews: 189,
      badge: 'G.M.P. Certified',
      benefits: ['Gastric Relief', 'Digestive Stimulant', 'Liver Tonic'],
      description: 'Pure herbal syrup for gastric complaints with 18 herbal ingredients including Mustak, Pudina, Arjun, Haritaki.',
      dosage: '10-20ml twice daily after meals',
      packing: '200ml & 400ml bottles',
      image: '/photos/gasso_win.jpeg'
    },
    {
      id: 3,
      name: 'VITAL COMPOUND',
      category: 'liver-health',
      rating: 4.8,
      reviews: 167,
      badge: 'Popular',
      benefits: ['Appetite Improvement', 'Mental Vitality', 'Immune Support'],
      description: 'Natural herbal restorative tonic with adaptogens including Moosli Safed, Ashwagandha, Satawari, Honey.',
      dosage: '10ml before or after principal meals',
      packing: '200ml & 400ml bottles',
      image: '/photos/vital_compounds.jpeg'
    },
    {
      id: 4,
      name: 'COUGH-CO',
      category: 'respiratory-care',
      rating: 4.6,
      reviews: 203,
      badge: null,
      benefits: ['Cough Relief', 'Bronchitis Care', 'Sore Throat'],
      description: 'Time-tested herbal cough syrup with Vasaka, Madhuyashti, Tulsi, Honey for respiratory issues.',
      dosage: 'Adults: 5-10ml 2-3 times daily; Children: 2.5-5ml',
      packing: '100ml bottle',
      image: '/photos/cough_co.jpeg'
    },
    {
      id: 5,
      name: 'LIVWIN',
      category: 'liver-health',
      price: '₹180',
      originalPrice: null,
      rating: 4.5,
      reviews: 134,
      badge: null,
      benefits: ['Liver Detox', 'Jaundice Care', 'Hepatoprotective'],
      description: 'Powerful herbal liver tonic with Bhumyamalaki, Bhringraj, Punarnava, Guduchi for liver health.',
      dosage: '5-10ml twice daily',
      packing: '100ml & 200ml bottles',
      image: '/photos/livwin_syrup.jpeg'
    },
    {
      id: 6,
      name: 'ACHE-WIN OIL',
      category: 'pain-relief',
      price: '₹85',
      originalPrice: '₹100',
      rating: 4.4,
      reviews: 178,
      badge: 'Topical',
      benefits: ['Muscular Pain', 'Arthritis Relief', 'Anti-inflammatory'],
      description: 'Herbal pain-relieving massage oil with Jyotismati, Vanharidra, Rasna in Sesame oil base.',
      dosage: 'Apply and massage 2-3 times daily (External use only)',
      packing: '25ml & 50ml bottles',
      image: '/photos/ache_win.jpeg'
    },
    {
      id: 7,
      name: 'VITAL DROPS (Pediatric)',
      category: 'pediatric-care',
      price: '₹140',
      originalPrice: null,
      rating: 4.7,
      reviews: 92,
      badge: 'Kids Safe',
      benefits: ['Liver Tonic', 'Growth Support', 'Mental Development'],
      description: 'Pediatric liver tonic with Punarnava, Guduchi, Brahmi, Shankhpushpi for healthy growth.',
      dosage: 'Infants: 5-10 drops; Children: 10-20 drops, three times daily',
      packing: '60ml bottle',
      image: '/photos/vital_drops.jpeg'
    },
    {
      id: 8,
      name: 'DYLOWIN TABLET',
      category: 'diabetes-care',
      price: '₹380',
      originalPrice: '₹450',
      rating: 4.8,
      reviews: 156,
      badge: 'Anti-Diabetic',
      benefits: ['Blood Sugar Control', 'Insulin Sensitivity', 'Diabetic Complications'],
      description: 'Herbal anti-diabetic formulation with 24 ingredients including herbs and mineral bhasmas.',
      dosage: '1-2 tablets twice daily',
      packing: '50 tablets bottle',
      image: '/photos/dylowin.jpeg'
    }
  ];

  const filteredProducts = activeCategory === 'all' 
    ? products 
    : products.filter(product => product.category === activeCategory);

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={i} className="star filled">★</span>
      );
    }

    if (hasHalfStar) {
      stars.push(
        <span key="half" className="star half">★</span>
      );
    }

    const remainingStars = 5 - stars.length;
    for (let i = 0; i < remainingStars; i++) {
      stars.push(
        <span key={`empty-${i}`} className="star empty">★</span>
      );
    }

    return stars;
  };

  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };

  const handleQuickView = (e, product) => {
    e.stopPropagation();
    navigate(`/product/${product.id}`, { state: { product } });
  };

  const handleContactForPrice = (e, product) => {
    e.stopPropagation();
    // Navigate to contact page with product information
    window.open(`/contact.html?product=${encodeURIComponent(product.name)}&id=${product.id}`, '_blank');
  };

  return (
    <section className="product-showcase section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Featured Products</h2>
          <p className="section-subtitle">
            Discover our carefully curated collection of authentic Ayurvedic products, 
            each formulated with premium ingredients for your wellness journey.
          </p>
        </div>

        {/* <div className="category-filters">
          {categories.map(category => (
            <button
              key={category.id}
              className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div> */}

        <div className="products-grid">
          {filteredProducts.map(product => (
            <div key={product.id} className="product-card">
              {product.badge && (
                <div className={`product-badge ${product.badge.toLowerCase().replace(' ', '-')}`}>
                  {product.badge}
                </div>
              )}
              
              <div className="product-image" onClick={() => handleProductClick(product)}>
                {product.image ? (
                  <img src={product.image} alt={product.name} className="product-img" />
                ) : (
                  <div className="product-image-placeholder"></div>
                )}
                <div className="product-hover-overlay">
                  <button 
                    className="quick-view-btn"
                    onClick={(e) => handleQuickView(e, product)}
                  >
                    Quick View
                  </button>
                </div>
              </div>
              
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                
                {product.description && (
                  <p className="product-description">{product.description}</p>
                )}
                
                <div className="product-benefits">
                  {product.benefits.slice(0, 2).map((benefit, index) => (
                    <span key={index} className="benefit-tag">
                      {benefit}
                    </span>
                  ))}
                </div>
                
                {product.dosage && (
                  <div className="product-dosage">
                    <strong>Dosage:</strong> {product.dosage}
                  </div>
                )}
                
                {product.packing && (
                  <div className="product-packing">
                    <strong>Available in:</strong> {product.packing}
                  </div>
                )}
                
                <div className="product-rating">
                  <div className="stars">
                    {renderStars(product.rating)}
                  </div>
                  <span className="rating-text">
                    {product.rating} ({product.reviews} reviews)
                  </span>
                </div>
                
                <div className="product-actions">
                  <button 
                    className="contact-price-btn btn btn-primary"
                    onClick={(e) => handleContactForPrice(e, product)}
                  >
                    Contact for Price
                  </button>
                  {/* <button className="wishlist-btn">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.5092 2.9987 7.05 2.9987C5.5908 2.9987 4.1917 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.0408 1.5487 8.5C1.5487 9.9592 2.1283 11.3583 3.16 12.39L12 21.23L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.06211 22.0329 6.39467C21.7563 5.72723 21.351 5.1208 20.84 4.61V4.61Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button> */}
                </div>
                
              </div>
            </div>
          ))}
        </div>

        <div className="showcase-cta">
          <a href="/products.html" className="btn btn-outline">
            View All Products
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;